import React, { useEffect, useRef, useState } from 'react'
import { useModals } from '../../hooks/useModals'
import ConfirmModalContent from '../ConfirmModalContent/ConfirmModalContent'
import DynamicFaIcon from '../DynamicFaIcon/DynamicFaIcon'

export interface ActionOption {
    action: () => void
    text: string
    type?: 'danger' | string
    contextType?: string
    showConfirmModal?: boolean
}

interface ActionButtonProps {
    options: ActionOption[]
}

const ActionButton: React.FunctionComponent<ActionButtonProps> = ({ options }: ActionButtonProps) => {
    const [actionButtonClicked, setActionButtonClicked] = useState<boolean>(false)
    const clickOutsideRef = useRef<any>()

    const { showModal, RenderModals } = useModals([
        {
            id: 'confirm',
            comp: ConfirmModalContent,
            props: {}
        }
    ])

    useEffect(() => {
        document.addEventListener('click', clickOutside)

        return () => {
            document.removeEventListener('click', clickOutside)
        }
    }, [])

    const clickOutside = (event: any) => {
        if (clickOutsideRef.current && !clickOutsideRef.current.contains(event.target)) {
            setActionButtonClicked(false)
        }
    }

    const handleAction = (option: ActionOption) => {
        if (option.showConfirmModal !== false) {
            showModal('confirm', {
                title: 'Weet je het zeker?',
                subtitle: `Weet je het zeker dat je deze ${option.contextType} wilt ${option.text}?`,
                primaryButtonText: option.text,
                primaryButtonAction: option.action,
                secondaryButtonText: 'Nee, sluiten',
                // onRequestClose: () => {},
                onConfirm: () => option.action()
            })
        } else {
            option.action()
        }
    }

    if (!options.length) {
        return null
    }

    return (
        <div className='relative'>
            <RenderModals />

            <button type='button' onClick={() => setActionButtonClicked(!actionButtonClicked)} ref={clickOutsideRef}>
                <DynamicFaIcon iconName='ellipsis' />
            </button>
            {actionButtonClicked && (
                <div className='border rounded-md bg-white cursor-pointer z-10 absolute mt-2 right-0'>
                    {options.map((option: ActionOption, i: number) => {
                        const textColor = option.type === 'danger' ? 'text-red-500' : 'text-[--tb-text]'

                        return (
                            <div key={i}>
                                <p
                                    className={`border px-8 py-2 hover:bgTextLightColor hover:bg-opacity-10 capitalize ${textColor}`}
                                    onClick={() => handleAction(option)}
                                >
                                    {option.text}
                                </p>
                            </div>
                        )
                    })}
                </div>
            )}
        </div>
    )
}

export default ActionButton
